import { Favorite, FavoriteBorder } from "@mui/icons-material";
import { Checkbox, IconButton } from "@mui/material";
import React from "react";
import {
  CUSTARD_CATEGORY,
  HAND_SCOOPED_CUSTARD_CATEGORY,
} from "../utils/constants";
import { getRecipeSignedUrl } from "./DigitalRecipePortal";

const RecipeActiveListItem = ({
  isThisBlockShow,
  category,
  tCount,
  tab,
  handleSellerCheckFromChild,
  categoryIndex,
  showImagePDF,
  containerOptions,
}) => {
  let gallon = false;
  let itemsCount = tCount;
  if (
    category?.intProductTypeID === HAND_SCOOPED_CUSTARD_CATEGORY ||
    category?.intProductTypeID === CUSTARD_CATEGORY
  ) {
    gallon = true;
    itemsCount = 2;
  }
  return (
    <div
      className="bg-white rounded-md"
      key={category?.intProductTypeID?.toString()}
      style={{
        display: isThisBlockShow(category) ? "" : "none",
      }}
    >
      <div className="card-header-border sticky bg-white z-50 top-[229px]">
        <div className="grid grid-cols-1 divide-x-0 ">
          <div
            sx={{ width: 8 - `${itemsCount}` }}
            className="pl-2 text-card-header"
          >
            <h6 className="text-card-header my-5">
              {`${category.product_type_name} (${
                category?.flavors.filter((itm) =>
                  (tab === 0 ? itm.is_recent : itm.favourite) && itm?.is_display
                )?.length
              })`}
            </h6>
          </div>
          <div sx={{ width: `${itemsCount}` }}></div>
        </div>
      </div>
      <div className="flow-root">
        <ul className="divide-gray-200 dark:divide-gray-700">
          {category?.flavors
            .filter((itm) => (tab === 0 ? itm.is_recent : itm.favourite) && itm?.is_display)
            .map((flv, flavorIndex) => {
              return (
                <li key={flavorIndex.toString()}>
                  <div className="grid grid-cols-2 divide-x-0 card-item-style  pl-2">
                    <div
                      sx={{
                        width: 8 - `${itemsCount}`,
                      }}
                      className="w-full pt-3"
                      style={{ display: "flex" }}
                    >
                      <span
                        className="flex-shrink-0 w-7"
                        style={{
                          verticalAlign: "bottom",
                        }}
                      >
                        <img
                          className="rounded-full"
                          src={getRecipeSignedUrl(flv.thumbnailURL)}
                          onError={(event) => {
                            event.target.src = "./assets/icons/circle.png";
                            event.onerror = null;
                          }}
                          alt="flvimage"
                        />
                        <Checkbox
                          onChange={(e) =>
                            handleSellerCheckFromChild(
                              e,
                              categoryIndex,
                              flv?.intFlavorID,
                              "favourite",
                              flv?.fid
                            )
                          }
                          checked={flv?.favourite}
                          style={{
                            position: "absolute",
                            marginTop: "-40px",
                            marginLeft: "10px",
                          }}
                          size="small"
                          icon={<FavoriteBorder className="text-gray-300" />}
                          checkedIcon={<Favorite color="error" />}
                        />
                      </span>
                      <span
                        style={{
                          fontSize: "12.5px",
                          paddingLeft: "12px",
                          paddingTop: "6px",
                        }}
                      >
                        {flv?.flavor_name}
                      </span>
                    </div>
                    <div
                      sx={{
                        width: `${itemsCount}`,
                      }}
                    >
                      <div
                        className={`grid text-center recipes-cards-tour-selector`}
                        style={{
                          marginTop: "16px",
                          gridTemplateColumns: `repeat(${itemsCount},1fr)`,
                        }}
                      >
                        {containerOptions.QC && !gallon && (
                          <div
                            onClick={(e) => showImagePDF(flv?.quarterContainer)}
                            style={{
                              color:
                                flv?.quarterContainer &&
                                flv?.quarterContainer !== "NA"
                                  ? "#0000EE"
                                  : "darkgrey",
                              cursor:
                                flv?.quarterContainer &&
                                flv?.quarterContainer !== "NA"
                                  ? "pointer"
                                  : "not-allowed",
                            }}
                          >
                            QC
                          </div>
                        )}
                        {containerOptions.HC && !gallon && (
                          <div
                            onClick={(e) => showImagePDF(flv?.halfContainer)}
                            style={{
                              color:
                                flv?.halfContainer &&
                                flv?.halfContainer !== "NA"
                                  ? "#0000EE"
                                  : "darkgrey",
                              cursor:
                                flv?.halfContainer &&
                                flv?.halfContainer !== "NA"
                                  ? "pointer"
                                  : "not-allowed",
                            }}
                          >
                            HC
                          </div>
                        )}
                              {containerOptions.SC && (
                        <>
                          {gallon ? (
                            <IconButton
                              title="Recipe Card"
                              disabled={
                                flv?.singleContainer &&
                                flv?.singleContainer !== "NA"
                                  ? false
                                  : true
                              }
                              disableTouchRipple
                              sx={{
                                width: 24,
                                height: 24,
                                padding: 0,
                                margin: "0 80px",
                                opacity:
                                  flv?.singleContainer &&
                                  flv?.singleContainer !== "NA"
                                    ? 1
                                    : 0.5,
                              }}
                              onClick={(e) =>
                                showImagePDF(flv?.singleContainer)
                              }
                            >
                              <img
                                // className="rounded-full"
                                style={{ width: "20px" }}
                                src={"../assets/icons/recipe-card-icon.png"}
                                alt="recipe"
                              />
                            </IconButton>
                          ) : (
                            <div
                              onClick={(e) =>
                                showImagePDF(flv?.singleContainer)
                              }
                              style={{
                                // marginTop: "8px",
                                paddingLeft: gallon ? "80px" : "0px",
                                color:
                                  flv?.singleContainer &&
                                  flv?.singleContainer !== "NA"
                                    ? "#0000EE"
                                    : "darkgrey",
                                cursor:
                                  flv?.singleContainer &&
                                  flv?.singleContainer !== "NA"
                                    ? "pointer"
                                    : "not-allowed",
                              }}
                            >
                              SC
                            </div>
                          )}
                        </>
                      )}
                        {containerOptions.DC && !gallon && (
                          <div
                            onClick={(e) => showImagePDF(flv?.doubleContainer)}
                            style={{
                              color:
                                flv?.doubleContainer &&
                                flv?.doubleContainer !== "NA"
                                  ? "#0000EE"
                                  : "darkgrey",
                              cursor:
                                flv?.doubleContainer &&
                                flv?.doubleContainer !== "NA"
                                  ? "pointer"
                                  : "not-allowed",
                            }}
                          >
                            DC
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </li>
              );
            })}
        </ul>
      </div>
    </div>
  );
};

export default RecipeActiveListItem;
